export const getColorByPercent = (percent: number) => {
  // Ограничиваем значение percent диапазоном от 0 до 100
  percent = Math.min(Math.max(percent, 0), 100)

  let red: number
  let green: number
  let blue: number = 0

  if (percent <= 50) {
    // 0-50%: от красного к желтому (увеличиваем зеленую составляющую)
    red = 255
    green = Math.round(255 * ((percent / 50) * 0.5))
  } else if (percent < 75) {
    // 50-75%: желтый (255, 255, 0)
    red = 255
    green = Math.round(255 * (percent / 50))
  } else {
    // 75-100%: от желтого к зеленому (уменьшаем красную составляющую)
    red = Math.round((100 - percent) * 0.25)
    green = 255
  }

  return `rgba(${red}, ${green}, ${blue}, 1)`
}
